'use client';

import type { ReactElement } from 'react';
import { Ctext } from '../Ctext';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Temper, TextAlign, getTemperColor } from '@/types/frontend-types';
import { CbullshitcodingSegments } from './CbullshitcodingSegments';
import type { DisplayLine } from './Cbullshitcoding.typing';

interface CbullshitcodingLineProps {
  line: DisplayLine;
  opacity: number;
  temper: Temper;
  textSize: number;
  align: TextAlign;
  cursor: string;
  debugIdentity: string;
}

const TEXT_ALIGN_BY_VALUE: Record<TextAlign, 'left' | 'center'> = {
  [TextAlign.Left]: 'left',
  [TextAlign.Center]: 'center',
};

export function CbullshitcodingLine({
  line,
  opacity,
  temper,
  textSize,
  align,
  cursor,
  debugIdentity,
}: CbullshitcodingLineProps): ReactElement {
  return (
    <Ctext
      className="cbullshitcoding__line"
      color={ColorType[getTemperColor(temper)]}
      opacity={opacity}
      size={textSize}
      weight={FontWeight.Regular}
      highlight={false}
      style={{
        overflowWrap: 'normal',
        textAlign: TEXT_ALIGN_BY_VALUE[align],
        whiteSpace: 'pre',
      }}
    >
      <CbullshitcodingSegments
        segments={line.segments}
        opacity={opacity}
        lineIdentity={debugIdentity}
      />
      {cursor}
    </Ctext>
  );
}
